"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Discussion = babelHelpers.interopRequireDefault(require("components/Discussion"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _EventActivityHeader = require("EventActivityHeader");

var _class, _descriptor, _temp, _class3, _descriptor2, _descriptor3, _descriptor4, _temp2, _class5, _descriptor5, _temp3;

var DiscussionHeader = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(DiscussionHeader, _Component);

  function DiscussionHeader() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, DiscussionHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(DiscussionHeader)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "node", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(DiscussionHeader, [{
    key: "render",
    value: function render() {
      if ('discussionHeader' in this.node) {
        var Type = require("discussionHeader.".concat(this.node.discussionHeader.type)).default;

        return _react.default.createElement(Type, {
          header: this.node.discussionHeader,
          node: this.node
        });
      }

      if ('activity' in this.node) return this.renderActivity();
      return this.renderCatalog();
    }
  }, {
    key: "renderDiscussionHeader",
    value: function renderDiscussionHeader() {
      var h = this.node.discussionHeader;
    }
  }, {
    key: "renderActivity",
    value: function renderActivity() {
      return _react.default.createElement("div", {
        className: "notification-assignment-header"
      }, _react.default.createElement("div", {
        className: "assignment-icon"
      }), _react.default.createElement("h4", null, "Assignment"), _react.default.createElement("div", {
        className: "activity-info"
      }, _react.default.createElement("h3", null, this.node.catalogItem.title), _react.default.createElement("h2", null, this.node.activity.title)));
    }
  }, {
    key: "renderCatalog",
    value: function renderCatalog() {
      return _react.default.createElement("div", {
        className: "notification-catalog-header"
      }, _react.default.createElement("h4", null, this.node.catalogItem.typeName), _react.default.createElement("div", {
        className: "catalog-info"
      }, _react.default.createElement("h3", null, this.node.catalogItem.title)));
    }
  }]);
  return DiscussionHeader;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var EventDetailBlock = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(EventDetailBlock, _Component2);

  function EventDetailBlock() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, EventDetailBlock);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(EventDetailBlock)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "node", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "eventDetail", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "children", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.state = {
      discussionVisible: false
    };
    return _this2;
  }

  babelHelpers.createClass(EventDetailBlock, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "event-detail-block-wrapper"
      }, _react.default.createElement("div", {
        className: "event-container"
      }, _react.default.createElement("div", {
        className: "body-outer"
      }, this.eventDetail.listImage ? _react.default.createElement("div", {
        className: "event-image"
      }, _react.default.createElement("img", {
        src: this.eventDetail.listImage,
        alt: ""
      })) : null, _react.default.createElement("div", {
        className: "event-header variable-background"
      }, _react.default.createElement(_EventActivityHeader.EventActivityHeader, {
        event: this.eventDetail
      })), _react.default.createElement("div", {
        className: "event-body",
        dangerouslySetInnerHTML: {
          __html: this.eventDetail.description
        }
      }))), _react.default.createElement("div", {
        className: "schedule-container"
      }, _react.default.createElement("div", {
        className: "schedule-toggle"
      }, _react.default.createElement("button", {
        className: "btn btn-primary",
        onClick: this.toggleDiscussion
      }, this.state.discussionVisible ? "Hide Scheduling Discussion" : "Show Scheduling Discussion")), this.state.discussionVisible ? this.children : null));
    }
  }, {
    key: "toggleDiscussion",
    value: function toggleDiscussion() {
      this.setState(function (_ref) {
        var discussionVisible = _ref.discussionVisible;
        return {
          discussionVisible: !discussionVisible
        };
      });
    }
  }]);
  return EventDetailBlock;
}(_react.Component), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "eventDetail", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "toggleDiscussion", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "toggleDiscussion"), _class3.prototype)), _class3);
var EventDetailViewer = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(EventDetailViewer, _Component3);

  function EventDetailViewer() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, EventDetailViewer);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(EventDetailViewer)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "item", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    _this3.state = {
      userProfile: null
    };
    return _this3;
  }

  babelHelpers.createClass(EventDetailViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      (0, _userProfile.getUserProfile)().then(function (value) {
        return _this4.setState({
          userProfile: value
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.userProfile) {
        return _react.default.createElement("div", null, _react.default.createElement(DiscussionHeader, {
          node: this.item
        }), _react.default.createElement(EventDetailBlock, {
          node: this.item,
          eventDetail: this.item.eventDetail
        }, _react.default.createElement(_Discussion.default, {
          discussionRoot: this.item.discussionRoot,
          userId: this.state.userProfile ? this.state.userProfile.id : null
        })));
      }

      return null;
    }
  }]);
  return EventDetailViewer;
}(_react.Component), _temp3), (_descriptor5 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
exports.default = EventDetailViewer;